import React from 'react'
import StudentHistoryTools from './StudentHistoryTools'
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect } from 'react';
import { StudentHistoryShowdata } from '../../services/LoginPageService';

const StudentHistory = () => {
  const [rows,setRow]=useState([]);
  const [isAddButton, setIsAddButton] = useState(true);
  const [editStudent, setEditStudent] = useState('');
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false); 
  const [refreshData, setRefreshData] = useState(false);
  const [isLoading, setGridLoading] = useState(true);
  const [openNotification, setNotification] = useState({
    status: false,
    type: 'error',
    message: '',
  });
  
  const columns = [
    {
      field: 'studentId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Campus Id',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'registrationNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Registration No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'studentName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'specialization',
      headerClassName: 'super-app-theme--header',
      headerName: 'Specialization',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'semester',
      headerClassName: 'super-app-theme--header',
      headerName: 'Year',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    // {
    //   field: 'section',
    //   headerClassName: 'super-app-theme--header',
    //   headerName: 'Section',
    //   minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    // },
    {
      field: 'gender',
      headerClassName: 'super-app-theme--header',
      headerName: 'Gender',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'studentContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Contact No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'emailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'parentsNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'parentsEmailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'altContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Alternate No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'rfid',
      headerClassName: 'super-app-theme--header',
      headerName: 'RFID',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
  ];

  useEffect(()=>{
    StudentHistoryShowdata(handleStudentHistoryShow,handeStudentHistoryException);
  },[refreshData]);
        
  const handleStudentHistoryShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }
  
  const handeStudentHistoryException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }

  return (
    <div>
      <StudentHistoryTools
      setIsAddButton={setIsAddButton}
      editStudent={editStudent}
      setOpen={setOpen}
      setOpen2={setOpen2}
      setEditStudent={setEditStudent} />

      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
        height: '480px',
        width: '100%',
        '& .super-app-theme--header': {
          WebkitTextStrokeWidth:'0.6px',
        },
        }}
      />
    </div>
  )
}

export default StudentHistory
